import styles from './styles.module.scss'
import { useParams } from 'react-router-dom'
import { API } from '@Root/API'
import { useEffect, useState, useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { snackbarActions } from '@Root/store'
import { errorMessage } from '@Root/helpers'
import { CognitoFormViewer } from '@Root/modules/Forms/CognitoFormViewer'
import { SubmissionDetailHeader } from '@Root/modules/Forms/components/SubmissionDetailHeader'
import { SubmissionInfo } from '@Root/modules/Forms/components/SubmissionInfo'

export const SubmissionPreview = () => {
  const { submissionId } = useParams()
  const [submissionData, setSubmissionData] = useState(null)
  const [rawData, setRawData] = useState(null)
  const [isLoading, setIsLoading] = useState(true)
  const [isResyncing, setIsResyncing] = useState(false)
  const dispatch = useDispatch()

  const fetchDataHandler = useCallback(async () => {
    try {
      setIsLoading(true)
      const response = await API.cognitoForms.getRawSubmissionData(submissionId)
      const payload = response.data || response
      const data = payload.data || payload

      setSubmissionData(data)

      const raw = data?.raw_data
      if (typeof raw === 'string') {
        try {
          setRawData(JSON.parse(raw))
        } catch (e) {
          setRawData(null)
        }
      } else {
        setRawData(raw || null)
      }
    } catch (error) {
      console.error('Error fetching submission data:', error)
      dispatch(snackbarActions.setSnackbar({ text: errorMessage(error), isError: true }))
    } finally {
      setIsLoading(false)
    }
  }, [submissionId, dispatch])

  useEffect(() => {
    fetchDataHandler()
  }, [fetchDataHandler])

  const handleResync = async () => {
    if (isResyncing) return
    setIsResyncing(true)
    try {
      const res = await API.cognitoForms.resyncSubmission(submissionId)
      const result = res.data || res
      if (result.success) {
        dispatch(snackbarActions.setSuccessNotification({ text: 'Resync completed successfully' }))
        fetchDataHandler()
      } else {
        dispatch(snackbarActions.setSnackbar({ text: result.message || 'Resync failed', isError: true }))
      }
    } catch (error) {
      dispatch(snackbarActions.setSnackbar({ text: errorMessage(error), isError: true }))
    } finally {
      setIsResyncing(false)
    }
  }

  if (isLoading) {
    return <div className={styles.loading}>Loading...</div>
  }

  return (
    <div className={styles.wrapper}>
      <SubmissionDetailHeader onResync={handleResync} isResyncing={isResyncing} applicationLink={submissionData?.application_link} />

      <SubmissionInfo data={submissionData} />

      <div className={styles.formShell}>
        <CognitoFormViewer data={rawData} title={submissionData?.form_name} />
      </div>
    </div>
  )
}
